import { images } from "@/data/resort";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

const features = [
  {
    id: "hike",
    title: "Hike",
    copy: "Explore Sierra Foothill trails and river canyon landscapes.",
    image: images.advHike,
    alt: "Hiking in the Sierra Foothills near Auburn",
  },
  {
    id: "ride",
    title: "Ride",
    copy: "Discover mountain biking routes throughout the Auburn area.",
    image: images.advRide,
    alt: "Mountain biking trails near Auburn California",
  },
  {
    id: "raft",
    title: "Raft",
    copy: "Experience whitewater adventures on regional rivers with qualified local outfitters.",
    image: images.advRafting,
    alt: "Whitewater rafting near the American River",
  },
];

export function FeaturedOutdoors() {
  return (
    <section
      id="featured-outdoors"
      aria-labelledby="featured-outdoors-heading"
      className="bg-forest-deep py-16 text-primary-foreground md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow tone="light">The Great Outdoors</Eyebrow>
        </Reveal>
        <h2 id="featured-outdoors-heading" className="display-lg mt-6 max-w-[14ch]">
          <MaskReveal>Find Your Wild Side</MaskReveal>
        </h2>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-primary-foreground/75">
            Outdoor activities may be seasonal and conditions can change. Confirm current access and
            availability before you go.
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-4 md:grid-cols-3">
          {features.map((item, i) => (
            <li key={item.id}>
              <Reveal delay={i * 0.07} className="h-full">
                <article className="group relative h-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.alt}
                    width={1200}
                    height={1400}
                    loading="lazy"
                    decoding="async"
                    className="aspect-[3/4] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/25 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-7">
                    <h3 className="font-display text-4xl tracking-tight md:text-5xl">
                      {item.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-primary-foreground/80">
                      {item.copy}
                    </p>
                  </div>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>

        <Reveal delay={0.12}>
          <a
            href="#destination-explorer"
            className="eyebrow mt-8 inline-flex text-accent transition-colors hover:text-primary-foreground"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("destination-explorer")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
              window.dispatchEvent(
                new CustomEvent("nearby-filter", { detail: { category: "Outdoors" } }),
              );
            }}
          >
            Explore Outdoor Adventures
          </a>
        </Reveal>
      </div>
    </section>
  );
}
